import React, { FC } from "react";
import { Box, Input, Typography } from "@mui/material";
import fileUploadService from "../../../services/fileUpload";
import { createFileName, getTimeStamp } from "../../../utils/helper";

interface IUploadFile {
  uploadBtnText: string;
  setUrl?: Function;
  protocolNumber?: string;
  name: string;
}

const UploadFile: FC<IUploadFile> = (props): JSX.Element => {
  const { uploadBtnText, setUrl, name, protocolNumber } = props;
  const handleFileUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    if (!e.target.files) return;

    try {
      if (setUrl) {
        const { data } = await fileUploadService.upload(
          e.target.files,
          protocolNumber
            ? createFileName(protocolNumber, name)
            : `${getTimeStamp()}-${name}`
        );
        setUrl(data);
      }
    } catch (err: any) {}
  };
  return (
    <Box className="upload-box upload-box-sm d-inline-block">
      <label htmlFor="singedConflict">
        <i className="icon-upload-cloud mg-r-10"></i>
        <Typography
          className="mg-r-6 font-size-sm font-weight-medium text-upload text-nowrap"
          variant={"subtitle1"}
          component={"span"}
        >
          {uploadBtnText}
        </Typography>
      </label>
      <div className="hidden-input">
        <Input
          id="singedConflict"
          type="file"
          className="form-control"
          name="profile-upload"
          onChange={handleFileUpload}
          inputProps={{accept: "application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.presentationml.presentation"}}
        />
      </div>
    </Box>
  );
};

export default UploadFile;
